// Campus photo for /colleges/university-of-dayton: CC BY-SA 4.0, by Nheyob, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AChapel_of_the_Immaculate_Conception_(University_of_Dayton)_-_exterior.JPG), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-dayton/; credited under the photo.
const photo = {
    "slug": "university-of-dayton",
    "alt": "The blue-domed Chapel of the Immaculate Conception and brick halls on the University of Dayton campus in Ohio",
    "src": "/colleges/university-of-dayton/campus-1600.webp",
    "srcSmall": "/colleges/university-of-dayton/campus-800.webp",
    "srcMid": "/colleges/university-of-dayton/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-dayton/og.jpg",
    "title": "Chapel of the Immaculate Conception (University of Dayton) - exterior",
    "author": "Nheyob",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AChapel_of_the_Immaculate_Conception_(University_of_Dayton)_-_exterior.JPG",
    "read": "2026-10-02"
};

export default photo;
